import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { trackPageView, getSessionId, getUserId } from "../utils/pageTracking";

const CompostOrderSuccess: React.FC = () => {
  useEffect(() => {
    trackPageView("CompostOrderSuccess", getSessionId(), getUserId());
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,#f7efe1,#f2f9ef_45%,#e6efe0_100%)] pt-16 text-slate-900">
      <section className="relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-[#c3d3ab]/40 blur-3xl" />
        <div className="absolute top-20 -left-20 h-56 w-56 rounded-full bg-[#f3c7a6]/40 blur-3xl" />
        <div className="container mx-auto px-6 py-16 text-center">
          <p className="mx-auto inline-flex items-center gap-2 rounded-full border border-[#b05e2c]/30 bg-white/80 px-4 py-2 text-sm font-semibold uppercase tracking-[0.25em] text-[#7a3d1a] shadow-sm">
            Compost Order Confirmed
          </p>
          <h1 className="mt-6 font-['Raleway'] text-4xl font-bold text-[#2f3a1f] md:text-5xl lg:text-6xl">
            Your compost is on the way
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-slate-700 md:text-xl">
            Thanks for placing a compost order with 1 Earth Composting. We are getting your bags ready and will follow up with delivery details shortly.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to="/orderCompost"
              className="inline-flex items-center justify-center rounded-lg bg-[#b05e2c] px-8 py-4 text-base font-semibold text-white transition-colors hover:bg-[#924d24]"
            >
              Place another order
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-lg border-2 border-[#2f3a1f] px-8 py-4 text-base font-semibold text-[#2f3a1f] transition-colors hover:bg-[#2f3a1f] hover:text-white"
            >
              Back to home
            </Link>
          </div>
        </div>

        <div className="mt-4 text-center bg-green-50 p-4 rounded-lg border-2 border-green-500 gap-8 flex flex-col items-center justify-center">
          <p className="text-lg text-gray-800 mb-2">
            Delivery is currently scheduled for mid April and beyond.
          </p>
          
        </div>
        <br/>
      </section>

      <section className="pb-16">

        <div className="container mx-auto grid max-w-5xl gap-6 px-6 md:grid-cols-3">
          <div className="rounded-2xl border border-white/70 bg-white/90 p-6 shadow-lg">
            <div className="text-3xl">📬</div>
            <h2 className="mt-4 font-['Raleway'] text-xl font-semibold text-[#2f3a1f]">
              Order is being prepared
            </h2>
            <p className="mt-3 text-slate-700">
              We have recieved your order and we are in the process of preparing your compost.
            </p>
          </div>
          <div className="rounded-2xl border border-white/70 bg-white/90 p-6 shadow-lg">
            <div className="text-3xl">🚚</div>
            <h2 className="mt-4 font-['Raleway'] text-xl font-semibold text-[#2f3a1f]">
              Delivery timeline
            </h2>
            <p className="mt-3 text-slate-700">
              We will contact you to confirm delivery timing for by the yard orders, bags will be delivered on pick updays.
            </p>
          </div>
          <div className="rounded-2xl border border-white/70 bg-white/90 p-6 shadow-lg">
            <div className="text-3xl">🌿</div>
            <h2 className="mt-4 font-['Raleway'] text-xl font-semibold text-[#2f3a1f]">
              Compost care
            </h2>
            <p className="mt-3 text-slate-700">
              Store bags in a dry spot and keep the compost loose for the healthiest soil when it arrives.
            </p>
          </div>
        </div>
      </section>

      <section className="border-t border-white/70 bg-white/70 py-10">
        <div className="container mx-auto px-6 text-center">
          <p className="text-base text-slate-700">
            Need to adjust your order or have a question?
          </p>
          <Link
            to="/contact-us"
            className="mt-3 inline-flex items-center justify-center text-base font-semibold text-[#b05e2c] underline-offset-4 hover:underline"
          >
            Contact the 1 Earth Composting team
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CompostOrderSuccess;
